/**
 * Rollout switches of the Documents extension (card 5.5). The default is the
 * manifest's `flags` entry; a device may override one for testing with
 * `localStorage.setItem('apiboo-flag:documents.scopes', 'true' | 'false')` and
 * a reload (the e2e suite turns workspaces on this way).
 *
 * Read synchronously and never cached, like utils/featureFlags.js: storage may
 * be unavailable, and the answer must not depend on store hydration order.
 */
import { documentsManifest } from './manifest';

const OVERRIDE_PREFIX = 'apiboo-flag:';

export function documentsFlag(name) {
  try {
    const raw = localStorage.getItem(`${OVERRIDE_PREFIX}${name}`);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
  } catch {
    /* storage unavailable — the manifest default stands */
  }
  return Boolean(documentsManifest.flags?.[name]);
}

/** User-defined document workspaces ("New workspace…", the workspace groups). */
export const documentsScopesEnabled = () => documentsFlag('documents.scopes');
